import { Box, BoxProps, SpacerNew, Text, TextProps } from '@jfs/ui-new'
import { Logo } from '../Logo'
interface ItemsProps {
  title: string
  subTitle?: string
  imageURL: string
  id: number
  authenticators?: Array<string>
  shortName?: string
  billPresentConsent?: boolean
  billPresentConsentDisplay?: boolean
  customerBillerAccountId?: number
  searchTags?: string
}

interface FavItemProps {
  item: ItemsProps
  handleNotification?: (item: ItemsProps) => void
  onPress: (item: ItemsProps) => void
}

const FavItem = (props: FavItemProps) => {
  const { item, onPress } = props
  const handlePress = () => onPress(item)
  return (
    <Box testID="operatorItem" {...styles.container} onPress={handlePress} underlayColor="GREY_SEPARATOR">
      <>
        <Box width={40} height="100%" justifyContent="center" alignContent="center">
          <Logo logo={props?.item?.imageURL ?? ''} type="medium" />
        </Box>

        <Box {...styles.containerRight}>
          <Text testID="title" {...styles.title}>
            {props.item?.title}
          </Text>
          {!!item?.subTitle && (
            <>
              <SpacerNew direction="vertical" size={6} />
              <Text testID="subTitle" {...styles.subTitle}>
                {item?.subTitle}
              </Text>
            </>
          )}
        </Box>
        {/* <Box height="100%" {...styles.nitificationIcon}>
          <Box {...styles.arrowBox}>
            <Icon id="ARROW_RIGHT" size={21} color="WHITE" />
          </Box>
        </Box> */}
      </>
    </Box>
  )
}

const styles = {
  underlay: '#F0F0F0',
  container: {
    height: 70,
    backgroundColor: 'WHITE',
    flexDirection: 'row',
    paddingHorizontal: 16,
    // paddingVertical: 8,
    alignItems: 'center',
    // marginHorizontal: 16,
    // borderBottomWidth: 1,
    // borderColor: 'LIGHTEST_GREY',
    // borderRadius: 8,
  } as BoxProps,
  containerRight: {
    marginHorizontal: 12,
    flexShrink: 1,
  } as BoxProps,
  title: {
    fontFamily: 'JioType-Medium',
    fontSize: 14,
    lineHeight: 20,
    color: 'BLACK',
  } as TextProps,
  subTitle: {
    fontFamily: 'JioType-Medium',
    fontSize: 14,
    color: 'LIGHT_GREY',
    paddingVertical: 4,
  } as TextProps,
  nitificationIcon: {
    position: 'absolute',
    right: 8,
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,
  arrowBox: {
    height: 25,
    width: 25,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 12,
    backgroundColor: 'GRAY_SHADOW',
  } as BoxProps,
}

export { FavItem }
